import React from 'react';
import "./skill.scss" ;

const Skill = () => {
  return (
    <div className='skill' id='skill'>
        <div className="top">
            <h2>what's in my Skills?</h2>
        </div>
        <div className="bottom">
            <img src="assets/js.png" alt="" />
            <img src="assets/cpp.png" alt="" />
            <img src="assets/python.png" alt="" />
            <img src="assets/reactjs.png" alt="" />
            <img src="assets/mongodb.png" alt="" />
            <img src="assets/bootstrap.png" alt="" />
            <img src="assets/nodejs.png" alt="" />
            <img src="assets/solidity.png" alt="" />
            <img src="assets/thunder.png" alt="" />
            <img src="assets/git.png" alt="" />
            <img src="assets/firebase.png" alt="" />
        </div>
    </div>
  )
}

export default Skill
